import { Helmet } from 'react-helmet-async';
import {
  SITE_NAME,
  DEFAULT_TITLE,
  formatPageTitle,
  resolveAbsoluteUrl,
  getSiteOrigin,
} from './siteConfig';

export default function SeoHead({
  title,
  description,
  image,
  url,
  type = 'website',
  noindex = false,
  jsonLd,
}) {
  const pageTitle = title ? formatPageTitle(title) : `${SITE_NAME} - ${DEFAULT_TITLE}`;
  const canonical =
    url ||
    (typeof window !== 'undefined'
      ? window.location.href.split('#')[0]
      : getSiteOrigin());
  const ogImage = resolveAbsoluteUrl(image);

  const jsonLdItems = jsonLd
    ? (Array.isArray(jsonLd) ? jsonLd : [jsonLd])
    : [];

  return (
    <Helmet>
      <title>{pageTitle}</title>
      {description && <meta name="description" content={description} />}
      {canonical && <link rel="canonical" href={canonical} />}
      {noindex && <meta name="robots" content="noindex, nofollow" />}

      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:title" content={pageTitle} />
      {description && <meta property="og:description" content={description} />}
      {canonical && <meta property="og:url" content={canonical} />}
      <meta property="og:type" content={type} />
      {ogImage && <meta property="og:image" content={ogImage} />}

      <meta
        name="twitter:card"
        content={ogImage ? 'summary_large_image' : 'summary'}
      />
      <meta name="twitter:title" content={pageTitle} />
      {description && <meta name="twitter:description" content={description} />}
      {ogImage && <meta name="twitter:image" content={ogImage} />}

      {jsonLdItems.map((item, index) => (
        <script key={index} type="application/ld+json">
          {JSON.stringify(item)}
        </script>
      ))}
    </Helmet>
  );
}
